import React, { createContext, useState } from "react";

const UploadDataContext = createContext();

const UploadDataProvider = ({ children }) => {
  const [step, setStep] = useState(1);
  const [file, setFile] = useState(null);
  const [jsonFile, setJsonFile] = useState([]);
  const [hasHeader, setHasHeader] = useState(false);
  const [dataSources, setDataSources] = useState([]);
  const [selectedDataSource, setSelectedDataSource] = useState(1);
  const [mappedData, setMappedData] = useState([]);

  const nextStep = () => {
    if (step < 3) setStep(prevStep => prevStep + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep(prevStep => prevStep - 1);
  };

  return (
    <UploadDataContext.Provider
      value={{
        step,
        file,
        setFile,
        nextStep,
        prevStep,
        jsonFile,
        setJsonFile,
        hasHeader,
        setHasHeader,
        selectedDataSource,
        setSelectedDataSource,
        mappedData,
        setMappedData,
        dataSources,
        setDataSources
      }}
    >
      {children}
    </UploadDataContext.Provider>
  );
};

export { UploadDataContext, UploadDataProvider };
